import { DEFAULT_REVIEW_SORT } from '@/constants/reviews';

export default {
  namespaced: true,

  state: () => ({
    reviews: [],
    reviewProductSummary: {},
    reviewProductInfo: {},
    reviewsMeta: {},
    isReviewsInitialLoaded: false,
    isReviewsSuccessLoaded: false,
    hasFitting: false,
  }),

  getters: {
    reviewProductSummary: (state) => state.reviewProductSummary || {},
    productReviews: (state) => state.reviews,
    reviewsMeta: (state) => state.reviewsMeta,
    currentReviewsPage: (state, getters) => getters.reviewsMeta?.currentPage || 0,
    reviewsCount: (state) => state.reviewProductInfo?.reviewsCount || 0,
    reviewRating: (state) => state.reviewProductInfo?.rating || 0,
    isReviewsSuccessLoaded: (state) => state.reviewProductInfo?.reviewsCount !== undefined,
  },

  actions: {
    async loadProductReviewsInfo({ commit }, { productId } = {}) {
      if (!productId) {
        throw new Error('не пепредан productId');
      }

      const response = await this.$apiBFF.getReviewsInfo({ productId });
      commit('setReviewProductInfo', response);
    },

    async loadProductReviews({ commit }, {
      productId, page = 1, sort = DEFAULT_REVIEW_SORT, onlyWithPhoto,
    } = {}) {
      if (!productId) {
        throw new Error('не пепредан productId');
      }

      try {
        const {
          meta,
          summary,
          reviews,
          status,
        } = await this.$apiBFF.getReviews({
          productId,
          page,
          sort,
          onlyWithPhoto,
        });

        if (status !== 500) {
          commit('setReviews', reviews);
          commit('setReviewProductSummary', summary);
          commit('setReviewsMeta', meta);
        }
      } finally {
        commit('setIsReviewsInitialLoaded', true);
      }
    },

    async loadMoreReviews({ commit, getters }, { productId, sort } = {}) {
      if (!productId) return;

      const page = getters.currentReviewsPage + 1;
      const { reviews, meta } = await this.$apiBFF.getReviews({ productId, page, sort });

      commit('addReviews', reviews);
      commit('setReviewsMeta', meta);
    },

    async voteForReview({ rootGetters }, { reviewId, isLike = true } = {}) {
      const voterId = rootGetters['user/account']?.id;

      if (!voterId || !reviewId) {
        throw new Error('Не переданы reviewId и voterId');
      }

      try {
        const result = await this.$apiBFF.voteForReview({ reviewId, isLike, voterId });

        if (!result.success && result.errors) {
          const error = Object.entries(result.errors)[0][1];

          return Promise.reject(error);
        }
        if (!result.success && !result.errors) {
          return Promise.reject();
        }
      } catch (error) {
        return Promise.reject();
      }
    },

    async addReview({ dispatch, rootGetters }, {
      rating,
      fitRating,
      qualityRating,
      photoAccuracyRating,
      body,
      pros,
      cons,
      recommended,
      authorName,
      locationName,
      dimensions,
      timeUsage,
      productId,
      photoIds,
    } = {}) {
      const showError = () => dispatch('notifications/create', {
        title: 'Произошла ошибка',
        message: 'Попробуйте позже',
      }, { root: true });

      try {
        const result = await this.$apiBFF.addReview({
          rating,
          fitRating,
          qualityRating,
          photoAccuracyRating,
          body,
          pros,
          cons,
          recommended,
          authorId: rootGetters['user/account']?.id,
          authorName,
          authorEmail: rootGetters['user/account']?.email || rootGetters['user/account']?.unconfirmedEmail,
          authorPhone: rootGetters['user/account']?.phone,
          locationName,
          productId,
          dimensions,
          timeUsage,
          photoIds,
        });

        if (result.success) {
          dispatch('notifications/create', {
            title: 'Спасибо за ваш отзыв',
            message: 'Он будет отправлен на модерацию',
            type: 'success',
          }, { root: true });

          return Promise.resolve();
        }

        showError();

        return Promise.reject();
      } catch (error) {
        if (error?.fields?.content_hash?.[0]?.error === 'taken') {
          dispatch('notifications/create', {
            title: 'Произошла ошибка',
            message: 'Вы уже отправляли такой отзыв',
          }, { root: true });
        } else {
          showError();
        }

        return Promise.reject();
      }
    },
  },

  mutations: {
    setReviews(state, reviews) {
      state.reviews = reviews;
    },

    addReviews(state, reviews) {
      state.reviews.push(...reviews);
    },

    setReviewProductSummary(state, reviewProductSummary) {
      state.reviewProductSummary = reviewProductSummary;
    },

    setReviewProductInfo(state, reviewProductInfo) {
      state.reviewProductInfo = reviewProductInfo;
    },

    setReviewsMeta(state, reviewsMeta) {
      state.reviewsMeta = reviewsMeta;
    },

    setIsReviewsInitialLoaded(state, value) {
      state.isReviewsInitialLoaded = value;
    },
  },
};
